(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-thunder-axe-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  var modal = document.querySelector('[data-ta-video-modal]');
  if (!modal) return;

  var frameHost = modal.querySelector('[data-ta-video-frame]');
  var closeEls = modal.querySelectorAll('[data-ta-video-close]');
  var triggers = document.querySelectorAll('[data-ta-video-trigger]');
  var lastFocused = null;

  function openModal(youtubeId, title) {
    if (!youtubeId) return;

    // Build the iframe only now — never on page load.
    var iframe = document.createElement('iframe');
    iframe.src =
      'https://www.youtube-nocookie.com/embed/' +
      encodeURIComponent(youtubeId) +
      '?autoplay=1&playsinline=1&rel=0';
    iframe.title = title || 'Video';
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;

    frameHost.innerHTML = '';
    frameHost.appendChild(iframe);

    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    lastFocused = document.activeElement;
    closeEls[0].focus();
  }

  function closeModal() {
    modal.hidden = true;
    // Removing the iframe stops playback immediately.
    frameHost.innerHTML = '';
    document.body.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      openModal(trigger.getAttribute('data-youtube-id'), trigger.getAttribute('data-video-title'));
    });
  });

  closeEls.forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (e) {
    if (!modal.hidden && e.key === 'Escape') {
      closeModal();
    }
  });

  // Sync mobile position dots with the swipeable track.
  var track = document.querySelector('.ta-testimonials__track');
  var dots = document.querySelectorAll('[data-ta-dot]');
  if (track && dots.length) {
    var updateDots = function () {
      var index = Math.round(track.scrollLeft / track.clientWidth) || 0;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    };
    track.addEventListener('scroll', updateDots, { passive: true });
    window.addEventListener('resize', updateDots);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
